<template>
  <div v-if="component && component.properties" ref="control" :class="['report-column-edit-rich-box', column.lineWrap && 'report-column-edit-column-normal']">
      <template v-if="component.properties.hidden">
        <el-tooltip v-if="showTooltip && !column.lineWrap" effect="dark" :content="formatter(value, 'content')" placement="top">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}"><span :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm" v-html="formatter(value)"></span></div>
        </el-tooltip>
        <div v-else class="span">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}"><span :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm" v-html="formatter(value)"></span></div>
        </div>
      </template>
      <template v-else>

        <el-tooltip v-if="showTooltip && !column.lineWrap && formatter(value)" effect="dark" :content="formatter(value, 'content')" placement="top">
          <div class="span" :style="{'line-height': !column.lineWrap && controlHeight}">
            <span v-html="formatter(value)" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm"></span>
            <i class="el-icon-edit" @click.stop="openWangEdit"></i>
          </div>
        </el-tooltip>
        <div v-else class="span" :style="{'line-height': !column.lineWrap && controlHeight}">
          <span v-html="formatter(value)" :class="this.report.clickColumn.appointColumn === this.column.id&&'appoint-column-name'" @click="openForm"></span>
          <i class="el-icon-edit" @click.stop="openWangEdit"></i>
        </div>
    </template>
     <el-dialog
      class="rich-box-dialog"
      :title="column.name"
      :visible.sync="richBox.visible"
      width="50%"
      center
      :modal-append-to-body="false">
      <div v-if="richBox.visible">
        <div class="editor" ref="editor" ></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveHtml">确 定</el-button>
        <el-button @click="richBox.visible=false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import publicMixin from './mixin'
import tokenStorage from '@/plugins/tokenStorage'
import Editor from 'wangeditor'
export default {
  name: 'report-rc-rich-box',
  mixins: [publicMixin],
  data () {
    return {
      editor: undefined,
      richBox: {
        visible: false,
        txt: ''
      }
    }
  },
  watch: {
    data: {
      handler (val) {
        this.value = val[this.column.id]
        this.error = ''
        this.edit = false
        this.getShowTooltip()
      },
      deep: true
    }
  },
  methods: {
    openWangEdit () {
      this.richBox.visible = true
      this.$nextTick(() => {
        this.initRichBox()
        this.setRichValue()
      })
    },
    initRichBox () {
      let self = this
      let token = tokenStorage.getToken()
      this.editor = new Editor(this.$refs.editor)
      this.editor.customConfig.showLinkImg = false
      this.editor.customConfig.zIndex = 100
      this.editor.customConfig.uploadImgTimeout = 30000
      // 自定义处理粘贴的文本内容
      this.editor.customConfig.pasteTextHandle = function (content) {
        // 设置了禁止粘贴
        if (self.component.properties.disablePaste) return ''
        // content 即粘贴过来的内容（html 或 纯文本），可进行自定义处理然后返回
        if (content === '' && !content) return ''
        let str = content
        // 处理的标签里的多余代码
        str = str.replace(/<xml>[\s\S]*?<\/xml>/ig, '')
        str = str.replace('/(\\n|\\r| class=(")?Mso[a-zA-Z]+(")?)/g', '')
        let reg = new RegExp('<!--(.*?)-->', 'g')
        str = str.replace(reg, '')
        return str
      }
      // 定义图片接受file name 名称后台定义的file
      this.editor.customConfig.uploadFileName = 'image'
      this.editor.customConfig.uploadImgHeaders = {
        'Authorization': token
      }
      this.editor.customConfig.uploadImgServer = `/shared-api/files/uploadImage`
      this.editor.customConfig.uploadImgParams = {type: 'USER'}
      this.editor.customConfig.uploadImgHooks = {
        error (xhr, editor) {
          this.$message.error('上传失败')
        },
        customInsert (insertImg, result, editor) {
          let url = self.getDownLoadUrl(result.data)
          insertImg(url)
        }
      }
      this.editor.customConfig.onchange = html => {
        this.richBox.txt = html
      }
      this.editor.create()
    },
    setRichValue () {
      if (this.value) {
        this.editor.txt.html(this.value)
      }
    },
    getDownLoadUrl (path) {
      return sessionStorage.getItem('ossDownloadUrl') + path
    },
    saveHtml () {
      this.richBox.visible = false
      this.update(this.richBox.txt)
    }
  }
}
</script>

<style lang="scss">
.rich-box-dialog {
  .editor {
    height: 100%;
    color: #000;
    .w-e-toolbar {
      display: block;
      background: #fff !important;
      border:1px solid #f1f1f1 !important;
      padding: 0;
      .w-e-menu {
        display: inline-block;
      }
    }
    .w-e-text {
      background: #fff;
      p {
        margin: 0;
        padding: 0;
      }
    }

  }
}
  .report-column-edit-rich-box {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    .span {
      font-size: 13px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding-right: 20px;
      height: 100%;
      line-height: 42px;
      span {
        font-size: 13px;
      }
      .el-icon-edit {
        position: absolute;
        right: 3px;
        top: calc(50% - 7px);
        cursor: pointer;
        color: #C2C3C4;
        display: none;
        &:hover {
          color: #55acf1;
        }
        &:active {
          color: #3079df;
        }
      }
      &:hover {
        .el-icon-edit {
          display: inline-block;
        }
      }
    }
    .input {
      width: 100%;
      height: 100%;
      .el-input {
        // .pagination-list .el-main .content .el-input 覆盖了
        width: 100% !important;
        height: 100%;
        -webkit-border-radius: 0;
        -moz-border-radius: 0;
        border-radius: 0;
        .el-input__inner {
          width: 100%;
          // .pagination-list .el-main .content .el-input .el-input__inner 这个样式覆盖了
          height: 100% !important;
          -webkit-border-radius: 0;
          -moz-border-radius: 0;
          border-radius: 0;
          font-size: 13px;
          color: #000;
        }
      }
    }
    .is-error {
      border-color: #F05459 !important;
      .el-input__inner {
        border-color: #F05459 !important;
      }
    }
    .error-message {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 2;
      background-color: #FEECEC;
      color: #F05459;
      border: 1px solid #F05459;
      padding: 0 5px;
      border-top: none;
      text-align: left;
      font-size: 12px;
    }
  }
  .report-column-edit-column-normal {
    position: relative;
    .span{
      white-space: normal;
      line-height: 26px;
      padding: 5px 25px 5px 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/reportColumnEdit/rc-rich-box.vue